import { render, staticRenderFns } from "./MailSignUp.vue?vue&type=template&id=4ba7dbc8&scoped=true&"
import script from "./MailSignUp.vue?vue&type=script&lang=js&"
export * from "./MailSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba7dbc8",
  null
  
)

export default component.exports